export function addArrowClass(classes: string, showArrow: boolean) {
  if (classes?.includes('arrow') || classes?.includes('noArrow')) return false;

  return showArrow ? 'arrow' : 'noArrow';
}
